export { ArticlesFeature } from './lib/articles'
export { genericArticleStaticPaths } from './lib/data/articles-data'
export { getStaticPathsGenerator } from './lib/get-static-paths'
export { getStaticPropsGenerator } from './lib/get-static-props'
